import { SearchFilter } from '../common/search-filter';

export class FilesIntegrationSearchCriteria extends SearchFilter {
	public CreationDateStart?: Date | null;
	public CreationDateEnd?: Date | null;
	public FileStatusList: string[];
	public FileTypeList: string[];
	public FileSubmitingCompanyFilterList: string[];
	public Filename: string;
}
